import classnames from 'classnames/bind'

// component
import ExploreFeedLiveItem from '../ExploreFeedLiveItem'

// Constants
import { FeedType } from '@/types/feed'
import { LiveFeedItemAccordionProps } from '../ExploreFeedLiveItem/LiveFeedItemAccordion'
// Libs

// Styles
import { VipShopType } from '@/api/fetchMemberVips'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type ExploreLiveListProps = {
  feeds: FeedType[]
  refetchCurrentPage?: () => void
  isMyLive?: boolean
  useFavoriteState?: boolean
  accordionProps?: LiveFeedItemAccordionProps
  vipShopList?: VipShopType[]
  showStartTime?: boolean
}

const ExploreLiveList = ({
  feeds = [],
  refetchCurrentPage,
  isMyLive = false,
  useFavoriteState = false,
  vipShopList = [],
  accordionProps,
  showStartTime = false,
}: ExploreLiveListProps) => {
  return (
    <div className={cx('live-list')}>
      {feeds.map((feed) => {
        return (
          <ExploreFeedLiveItem
            key={feed.meta.roomId}
            {...feed}
            refetchCurrentPage={refetchCurrentPage}
            isMyLive={isMyLive}
            useFavoriteState={useFavoriteState}
            accordionProps={accordionProps}
            buttons={feed.buttons}
            footer={feed.footer}
            vipShopList={vipShopList}
            showStartTime={showStartTime}
          />
        )
      })}
    </div>
  )
}
export default ExploreLiveList
